var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCol',{staticClass:"text-center",attrs:{"col":"12"}},[_c('CButton',{attrs:{"size":"lg","color":"warning"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("Try Again")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }